import { lighten, darken } from 'polished'

export const primaryColor = '#003b69'
export const primaryVariantColor = '#002d4f'
export const secondaryColor = '#ff1053'
export const secondaryVariantColor = '#d8006c'

export const backgroundColor = '#ffffff'
export const surfaceColor = '#ffffff'
export const errorColor = '#b00020'

export const onPrimaryColor = '#ffffff'
export const onPrimaryVariantColor = '#ffffff'
export const onSecondaryColor = '#000000'
export const onSecondaryVariantColor = '#000000'

export const onBackgroundColor = '#000000'
export const onSurfaceColor = '#000000'

export const subtleColor = '#e5e5e5'
export const grayColor = '#d3d3d3'

export const greenColor = '#22aa44'
export const orangeColor = '#ffa524'

export const backdropColor = 'rgba(0, 0, 0, 0.4)'

export const primary050 = lighten(0.9, primaryColor)
export const primary100 = lighten(0.8, primaryColor)
export const primary200 = lighten(0.6, primaryColor)
export const primary300 = lighten(0.4, primaryColor)
export const primary400 = lighten(0.2, primaryColor)
export const primary500 = primaryColor
export const primary600 = darken(0.2, primaryColor)
export const primary700 = darken(0.4, primaryColor)
export const primary800 = darken(0.6, primaryColor)
export const primary900 = darken(0.8, primaryColor)

export const secondary050 = lighten(0.9, secondaryColor)
export const secondary100 = lighten(0.8, secondaryColor)
export const secondary200 = lighten(0.6, secondaryColor)
export const secondary300 = lighten(0.4, secondaryColor)
export const secondary400 = lighten(0.2, secondaryColor)
export const secondary500 = secondaryColor
export const secondary600 = darken(0.2, secondaryColor)
export const secondary700 = darken(0.4, secondaryColor)
export const secondary800 = darken(0.6, secondaryColor)
export const secondary900 = darken(0.8, secondaryColor)

export const gray050 = lighten(0.9, grayColor)
export const gray100 = lighten(0.8, grayColor)
export const gray200 = lighten(0.6, grayColor)
export const gray300 = lighten(0.4, grayColor)
export const gray400 = lighten(0.2, grayColor)
export const gray500 = grayColor
export const gray600 = darken(0.2, grayColor)
export const gray700 = darken(0.4, grayColor)
export const gray800 = darken(0.6, grayColor)
export const gray900 = darken(0.8, grayColor)

export const dangerColor = '#ff4444'
export const dangerColorDark = '#cc0000'
export const warningColor = '#ffbb33'
export const warningColorDark = '#ff8800'
export const successColor = '#00c851'
export const successColorDark = '#007e33'
export const infoColor = '#33b5e5'
export const infoColorDark = '#0099cc'
